import { TemplateSubmission } from "common/Database";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { defaultRootState } from "./default-root-state";
import { castDraft } from "immer";

const slice = createSlice({
    name: "templateSubmissions",
    initialState: defaultRootState.templateSubmissions,
    reducers: {
        setTemplateSubmissions: (state, action: PayloadAction<readonly TemplateSubmission[]>) => {
            state.submissions = castDraft(action.payload) as any; // type error in original code, ported faithfully
        },
    },
});

export const { setTemplateSubmissions } = slice.actions;
export default slice.reducer;
